export function formatEngineSizeForDisplay(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return 'n/a';
  }

  const normalized = raw.toLowerCase().replace(/,/g, '');
  if (normalized === 'ev') {
    return 'EV';
  }

  let ccValue = null;
  const ccMatch = normalized.match(/(\d+(?:\.\d+)?)\s*cc\b/);

  if (ccMatch) {
    ccValue = Number(ccMatch[1]);
  } else if (/^\d+(?:\.\d+)?$/.test(normalized)) {
    const numericValue = Number(normalized);
    if (Number.isFinite(numericValue) && numericValue > 20) {
      ccValue = numericValue;
    }
  }

  if (ccValue && Number.isFinite(ccValue) && ccValue > 0) {
    const litres = Math.round((ccValue / 1000) * 10) / 10;
    return `${litres.toFixed(1)}L`;
  }

  return raw;
}
